// 隐私政策管理
import http from "@/jslibs/axios/http";

// 隐私政策更新
export const edit = (data) => http.post("/v1/cms/PrivacyPolicy", data);

// 隐私政策详情
export const detail = (data) => http.get("/v1/cms/PrivacyPolicy", data);
